import { useEffect } from "react";
import { alpha, Box, IconButton, useTheme } from "@mui/material";
import { Icon, iconClose } from "theme/icons";
import { useNavigate } from "react-router-dom";
import { SuspenseLoader } from "utils/helpers/LoadingIndicator";

export const Game = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const gameContainerName = "game";

  useEffect(() => {
    const script = document.createElement("script");
    script.setAttribute("id", "embed-script-v1");
    script.setAttribute("type", "application/javascript");
    script.setAttribute("src", "https://play.flarie.com/embed.js");
    // script.setAttribute("expander", "true");
    script.setAttribute("height", "100vh");
    script.setAttribute("async", "true");
    script.setAttribute("embed-url", "https://gamecenter.flarie.com/16931167-33eb-4726-9c2f-62a75b489697");

    const gameContainer = document.getElementById(gameContainerName);
    if (!gameContainer) throw new Error("Game container not found");

    gameContainer.replaceChildren(script);

    script.onload = () => {
      console.log("Game script loaded successfully");

      setTimeout(() => {
        gameContainer.style.display = "block";
        document.getElementById("loader")?.remove();
      }, 2000);
    };

    return () => {
      if (script) script.remove();
    };
  }, []);

  const handleClose = () => {
    navigate(-1);
  };

  return (
    <Box sx={{ position: "absolute", left: 0, right: 0, bottom: 0, top: 0 }}>
      <IconButton
        onClick={handleClose}
        sx={{
          position: "absolute",
          backgroundColor: alpha(theme.palette.primary.main, 0.75),
          zIndex: 5,
          top: 16,
          left: 16,
          "&:hover": { backgroundColor: "rgba(0,0,0,0.5)" },
        }}
      >
        <Icon name={iconClose} htmlColor="white" />
      </IconButton>
      <Box id="loader">
        <SuspenseLoader text="Vi startar ditt spel..." />
      </Box>
      <Box id={gameContainerName} sx={{ display: "none" }}></Box>
    </Box>
  );
};
